import { createPositionResolver } from './resolver'
import type { PositionDef } from './types'

export const AmfPosition = {
  Quarterback: 'Quarterback',
  RunningBack: 'RunningBack',
  WideReceiver: 'WideReceiver',
  TightEnd: 'TightEnd',
  OffensiveLine: 'OffensiveLine',
  DefensiveLine: 'DefensiveLine',
  Linebacker: 'Linebacker',
  Safety: 'Safety',
  Cornerback: 'Cornerback',
  Kicker: 'Kicker',
  Punter: 'Punter',
  LongSnapper: 'LongSnapper',
  SpecialTeams: 'SpecialTeams'
} as const

export type AmfPosition = (typeof AmfPosition)[keyof typeof AmfPosition]

export const amfPositions: ReadonlyArray<PositionDef<AmfPosition>> = [
  {
    canonical: AmfPosition.Quarterback,
    abbreviation: 'QB',
    label: 'Quarterback',
    aliases: ['quarter back', 'quarterbacks']
  },
  {
    canonical: AmfPosition.RunningBack,
    abbreviation: 'RB',
    label: 'Running Back',
    aliases: ['running back', 'runningback', 'runningbacks', 'rusher']
  },
  {
    canonical: AmfPosition.WideReceiver,
    abbreviation: 'WR',
    label: 'Wide Receiver',
    aliases: ['wide receivers', 'wide-receiver', 'receiver', 'receivers']
  },
  {
    canonical: AmfPosition.TightEnd,
    abbreviation: 'TE',
    label: 'Tight End',
    aliases: ['tight ends', 'tightend']
  },
  {
    canonical: AmfPosition.OffensiveLine,
    abbreviation: 'OL',
    label: 'Offensive Line',
    aliases: ['offensive lineman', 'o-line', 'oline', 'offensive linemen']
  },
  {
    canonical: AmfPosition.DefensiveLine,
    abbreviation: 'DL',
    label: 'Defensive Line',
    aliases: ['defensive lineman', 'd-line', 'dline', 'defensive linemen']
  },
  {
    canonical: AmfPosition.Linebacker,
    abbreviation: 'LB',
    label: 'Linebacker',
    aliases: ['linebackers', 'line backer']
  },
  {
    canonical: AmfPosition.Safety,
    abbreviation: 'S',
    label: 'Safety',
    aliases: ['safeties', 'free safety', 'strong safety', 'fs', 'ss']
  },
  {
    canonical: AmfPosition.Cornerback,
    abbreviation: 'CB',
    label: 'Cornerback',
    aliases: ['corner back', 'cornerbacks', 'corner']
  },
  {
    canonical: AmfPosition.Kicker,
    abbreviation: 'K',
    label: 'Kicker',
    aliases: ['kickers', 'place kicker']
  },
  {
    canonical: AmfPosition.Punter,
    abbreviation: 'P',
    label: 'Punter',
    aliases: ['punters']
  },
  {
    canonical: AmfPosition.LongSnapper,
    abbreviation: 'LS',
    label: 'Long Snapper',
    aliases: ['long snappers', 'longsnapper']
  },
  {
    canonical: AmfPosition.SpecialTeams,
    abbreviation: 'ST',
    label: 'Special Teams',
    aliases: ['special team', 'specialteams']
  }
]

export const amfPositionResolver = createPositionResolver(amfPositions)
